import type { ChatConfig } from "@/common/types/chat.types";
import ChatHeader from "../ChatHeader/ChatHeader";
import styles from "./CloseChatModal.module.css";
import { closeChat, minimizeChat } from "@/widget-entry";

interface CloseModalProps {
  onCancelCloseChat: () => void;
  onConfirmCloseChat: () => void;
  config: ChatConfig;
}

const CloseChatModal = ({ onCancelCloseChat, onConfirmCloseChat, config }: CloseModalProps) => {
  return (
    <section className={styles.closeModal}>
      <ChatHeader
        botName={config.botDisplayName}
        botAvatarURL={config.botAvatarImageURL}
        onMinimize={minimizeChat}
        onClose={closeChat}
        visibleBotAvatar={config.visibleBotAvatar}
        minimizeButtonImage={config.minimizeChatImageURL}
        closeButtonImage={config.closeChatImageURL}
      />
        <section className={styles.closeChatContentSection}>
          <p>Är du säker på att du vill avsluta den här chattsessionen?</p>
          <p>All chatthistorik kommer att försvinna.</p>
          <button className={styles.button} aria-label="Stäng chatten" onClick={onConfirmCloseChat}>Stäng</button>
          <button className={styles.button} aria-label="Tillbaka till chatten" onClick={onCancelCloseChat}>Tillbaka till chatten</button>
        </section>
    </section>
  );
};

export default CloseChatModal;